import { TrackingServiceV2 } from '@oneaudi/audi-tracking-service';

export const trackFeatureAppReady = (
  trackingService: TrackingServiceV2,
  featureAppVersion: String
) => {
  if (trackingService) {
    trackingService.track({
      event: {
        eventInfo: {
          eventAction: 'feature_app_ready',
          eventName: 'warranty display - feature app ready',
        },
        attributes: {
          componentName: 'warranty-display',
          label: '',
          targetURL: '',
          clickID: '',
          elementName: '',
          value: '',
          pos: '',
        },
      },
      componentUpdate: {
        componentInfo: {
          implementer: 2,
          version: featureAppVersion,
        },
      },
    });
  }
};

export const registerImpressionTracking = (trackingService: TrackingServiceV2, ref: any) => {
  if (trackingService) {
    if (ref !== null) {
      trackingService.registerImpressionTracking(ref.current, () => {
        return {
          event: {
            eventInfo: {
              eventAction: 'impression',
              eventName: 'warranty display - impression',
            },
            attributes: {
              componentName: 'warranty-display',
              label: '',
              targetURL: '',
              clickID: '',
              elementName: '',
              value: '',
              pos: '',
            },
          },
        };
      });
    }
  }
};

export const trackClick = (
  trackingService: TrackingServiceV2,
  eventAction: string,
  eventName: string,
  label: string,
  targetURL: string,
  elementName: string,
  value: string,
  pos: string
) => {
  if (trackingService) {
    trackingService.track({
      event: {
        eventInfo: {
          eventAction,
          eventName,
        },
        attributes: {
          componentName: 'warranty-display',
          label,
          targetURL,
          clickID: '',
          elementName,
          value,
          pos,
        },
      },
    });
  }
};
